import type { Socket } from 'socket.io-client';
import {
  createNotificationSocket,
  everySocket,
} from './connectNotificationSocket';
import { createSessionSockets } from './sessionSockets';

// NX-5877: the namespace refuses a handshake without a live session and puts
// the socket in that session's rooms. The session's system — the one its HTTP
// requests go to — is known only once the session exists (a hand-off brings
// its own, after this module has loaded), so there is a socket per system.
// AppLayout connects the session's one through connectNotificationSocket,
// which also supplies the credentials.
const notificationSockets: Record<'bureau' | 'umbrella', Socket> = {
  bureau: createNotificationSocket(import.meta.env.VITE_SOCKET_BUREAU_URL),
  umbrella: createNotificationSocket(import.meta.env.VITE_SOCKET_URL),
};

export const notificationSocketOf = (bureau: boolean): Socket =>
  bureau ? notificationSockets.bureau : notificationSockets.umbrella;

// Listeners go on both sockets: only the connected one hears anything, and
// none has to move when a session changes system.
export const socketNotification = everySocket(
  Object.values(notificationSockets),
);

// NX-6269: these namespaces' events come from the session's own system too.
// AppLayout tells them which system that is. Their handshakes present the
// session's credentials, as the notification socket's do.
const sessionSockets = createSessionSockets({
  bureau: import.meta.env.VITE_SOCKET_BUREAU_URL,
  umbrella: import.meta.env.VITE_SOCKET_URL,
});

export const setSessionSystem = sessionSockets.setSystem;

export const reconnectSessionSockets = sessionSockets.reconnect;

export const socketImportProcess = sessionSockets.socketOf(
  'import-process-notification',
);

export const socketPayroll = sessionSockets.socketOf('payroll-job');

export const socketNaersaProcess = sessionSockets.socketOf(
  'naersa-notification',
);

export const socketExportAllSubcontractor = sessionSockets.socketOf(
  'export-all-subcontractor-processing-notification',
);

export const socketYearEndProcess = sessionSockets.socketOf('year-end-process');

export const socketConversation = sessionSockets.socketOf('conversation');

export const socketZohoSignContract =
  sessionSockets.socketOf('zoho-sign-contract');

export const socketOnboarding = sessionSockets.socketOf('new-onboarding');

// NX-6291: where the multiple-select Invite Onboarding job reports.
export const socketInviteOnboarding =
  sessionSockets.socketOf('invite-onboarding');
